export default __webpack_public_path__ + "20f883fd8b0bd789bb6df0e36eadcab5.png";